<div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <div class="card-header-title">
      <h2 class="my-0" style="color: #224261">{{ 'reports_irrigation_costs' | translation }}</h2>
    </div>
    <button
      *ngIf="terminal"
      (click)="openForm(null)"
      class="btn btn-primary">
      {{ 'add' | translation }}
    </button>
  </div>
  <div class="card-body">
    <h3 *ngIf="!terminal">{{ 'reports_select_device' | translation }}</h3>
    <section *ngIf="terminal" class="table-responsive">
      <table class="table table-hover mb-0">
        <thead>
        <tr>
          <th scope="col" class="text-uppercase fs-6">{{ 'start_date' | translation }}</th>
          <th scope="col" class="text-uppercase fs-6">{{ 'end_date' | translation }}</th>
          <th scope="col" class="text-uppercase fs-6">{{ 'reports_costs' | translation }}</th>
          <th scope="col" class="text-uppercase fs-6">{{ 'reports_origin' | translation }}</th>
          <th scope="col" class="text-uppercase fs-6">{{ 'irrigation_water_system' | translation }}</th>
          <th scope="col" class="text-uppercase fs-6 text-end">{{ 'terminal_actions' | translation}}</th>
        </tr>
        </thead>
        <tbody class="fs-4">
        <tr *ngIf="irrigationCosts.length === 0">
          <td colspan="6">{{ 'no_results' | translation }}</td>
        </tr>
        <tr *ngFor="let cost of irrigationCosts">
          <td>{{ cost.start_date | date: 'dd/MM/yyyy' }}</td>
          <td>{{ cost.end_date | date: 'dd/MM/yyyy' }}</td>
          <td>{{ cost.cost | amount : terminalCurrency.currency }}/m³</td>
          <td>{{ waterSourceName(cost.water_source_vid) }}</td>
          <td>{{ cost.water_system + 1 }}</td>
          <td class="text-end">
            <div class="d-flex justify-content-end align-items-center">
              <button
                class="btn btn-outline-primary btn-sm me-2"
                (click)="onEdit(cost)">
                <i class="bi bi-pencil"></i>
              </button>
              <button
                class="btn btn-outline-danger btn-sm"
                (click)="onDelete(cost)">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </section>
  </div>
</div>

<ion-modal [isOpen]="false" (willDismiss)="onWillDismiss($event)" #modal class="auto-height">
  <ng-template>
    <ion-toolbar>
      <ion-title>
        {{ selectedIrrigationCost ? ('reports_edit_irrigation_costs' | translation) : ('reports_add_irrigation_costs' | translation) }}
      </ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="modal.dismiss()">
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <div class="container p-4">
      <app-irrigation-cost-form
        [terminal]="terminal"
        [source]="selectedIrrigationCost"
        (formSubmitted)="onFormSubmitted()"
        (formCancelled)="modal.dismiss()">
      </app-irrigation-cost-form>
    </div>
  </ng-template>
</ion-modal>
